!(function() {
  'use strict';
  const { create } = require('lodash/fp');
  /**
   * Error object for validation. It derives Error object. It is used for wrapping
   * validation errors in an Error object to avoid warning of bluebirdjs Promise
   * resolving. If not, Bluebirdjs complaints a Promise has been rejected by
   * non Error object.
   * @param {Array} errors An error array.
   */
  function ValidationErrors(errors) {
    this.errors = errors;
  }
  ValidationErrors.prototype = create(Error.prototype, {
    constructor: ValidationErrors
  });

  module.exports = ValidationErrors;
})();



// WEBPACK FOOTER //
// ./ui/share/validation/Izenda.ValidationErrors.js